import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

// Services
import { IGetQuestionsCommentResponse } from '../../services/question';

export type IComment = IGetQuestionsCommentResponse;

// Components
import Dialog from '../Dialog';
import ScrollHandler from '../ScrollHandler';

import CommentsDialogList from './CommentsDialogList';
import CommentsDialogInput from './CommentsDialogInput';

// Style
import './CommentsDialog.css';

// Component
interface IProps {
  comments: IComment[] | null;
  state: { open: boolean; questionId: string | null; networkId: string | null };
  onClose?: () => void;
  onExited?: () => void;
  onSubmit: (comment: string) => Promise<void>;
}

class CommentsDialog extends React.Component<IProps, {}> {
  @observable inputValue: string = '';

  handleExited = () => {
    this.inputValue = '';
    if (this.props.onExited) {
      this.props.onExited();
    }
  };

  handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.inputValue = e.currentTarget.value;
  };

  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.props.onSubmit(this.inputValue);
    this.inputValue = '';
  };

  render() {
    return (
      <Dialog
        open={this.props.state.open}
        onClose={this.props.onClose}
        onExited={this.handleExited}
        classes={{ paper: 'CommentsDialog_paper' }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <ScrollHandler
            style={{ flexGrow: 1, maxHeight: '100%', overflowY: 'auto' }}
          >
            <CommentsDialogList comments={this.props.comments} />
          </ScrollHandler>
          <CommentsDialogInput
            inputValue={this.inputValue}
            onInputChange={this.handleInputChange}
            onSubmit={this.handleSubmit}
          />
        </div>
      </Dialog>
    );
  }
}

export default observer(CommentsDialog);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CommentsDialog/CommentsDialog.tsx